import React from 'react';

function MenuCategory(props) {
	const { name } = props;
	return <div className="ls-menu-items-header">{name}</div>;
}

export default MenuCategory;
